// UI-A T1: regra de presença do botão olho (função pura).
// Níveis: 0 = interface visível; 1 = interface oculta pelo olho (olho continua);
// 2 = oculta total (captura de feedback) — NÃO é alcançável pelo olho.

/** Próximo nível ao tocar o olho: alterna 0 <-> 1 (nunca chega ao 2). */
export function nextEyeLevel(level: number): number {
  return level === 0 ? 1 : 0;
}

/** O olho some só por ociosidade, oculta total (2) ou antes da 1ª interação. */
export function eyeVisible(level: number, idle: boolean, hasInteracted: boolean): boolean {
  if (!hasInteracted) return false;
  if (idle) return false;
  if (level === 2) return false;
  return true;
}

/** Toque na tela durante a ociosidade traz a interface de volta (nível 0). */
export function levelAfterScreenTouch(level: number, wasIdle: boolean): number {
  return wasIdle ? 0 : level;
}
